import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for migrated `/change-log/*` URLs.
 *
 * Kept separate from `changeLog.ts` (the `RouteObject` tree) so `RouteUrls.ts` and pages can
 * import paths without creating a cycle through page `Component` imports.
 *
 * Nested routes compose from their parent's `.path` so the hierarchy stays visible and absolute
 * strings stay in sync (RR6 requires a child's path to start with its parent's).
 */
export const changeLogRoute = defineRoute("/change-log");
export const changeLogDetailsRoute = defineRoute(`${changeLogRoute.path}/:changeRequestId`);
export const changeTypesRoute = defineRoute(`${changeLogRoute.path}/change-types`);
export const businessFunctionsRoute = defineRoute(`${changeLogRoute.path}/functions`);
export const businessFunctionDetailsRoute = defineRoute(`${businessFunctionsRoute.path}/:businessFunctionId`);
